// config/apiConfig.js
export const BASE_URL = "https://lense-celery-120996668109.asia-south1.run.app";

//export const BASE_URL = "https://lensetesting.quantapeople.com/lensetesting";

//export const BASE_URL="https://lense-production-120996668109.asia-south1.run.app/";


 